// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebaseConfig: {
      apiKey: "AIzaSyAjH42aTTMLo8-hqX2lR2aAXKC5GQoSzvs",
      authDomain: "athlos-sports.firebaseapp.com",
      databaseURL: "https://athlos-sports.firebaseio.com",
      projectId: "athlos-sports",
      storageBucket: "athlos-sports.appspot.com",
      messagingSenderId: "122148360443"
    }
};



// WEBPACK FOOTER //
// C:/Users/beast/repos/athlos-admin/src/environments/environment.ts